import { useEffect, useRef } from 'react';

export default function useSchoolExamSync(refresh, onDeleted) {
  const callbacks = useRef({ refresh, onDeleted });
  callbacks.current = { refresh, onDeleted };

  useEffect(() => {
    const sync = event => {
      const notification = event?.detail;
      if (notification?.meta?.deleted) {
        callbacks.current.onDeleted?.(String(notification.meta.examId || notification.entityId));
      }
      callbacks.current.refresh();
    };
    const onVisible = () => {
      if (document.visibilityState === 'visible') sync();
    };
    window.addEventListener('school-exam-changed', sync);
    window.addEventListener('focus', sync);
    window.addEventListener('online', sync);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      window.removeEventListener('school-exam-changed', sync);
      window.removeEventListener('focus', sync);
      window.removeEventListener('online', sync);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);
}
